import template from './permissions.html';

class PermissionsComponent {
  /** @ngInject */
  constructor(
    $log, $q, $mdDialog, $mdToast, $state,
    AccessService
  ) {
    this.$log = $log;
    this.$q = $q;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.AccessService = AccessService;

    this.employeesAccess = [];
    this._employees = [];
    this.disabledCheckbox = false;
    this.columnKeys = ['fullNameWithAccount', 'attendance'];
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.employees) {
      angular.copy(this.employees, this._employees);
    }

    if (changes.access) {
      this.access = {...this.access};
    }
  }

  $onInit() {
    if (this.access && this._employees) {
      this.employeesAccess = this._employees.map(employee => {
        const access = this.getAccessForEmployee(this.access, employee.id);
        if (access.length > 0) {
          Object.assign(employee, access[0]);
        }

        return employee;
      });
    }
  }

  getAccessForEmployee(access, id) {
    let result = [];
    result = access.employees.filter(employee => {
      employee.globalAccessEntries.map(item => {
        employee[item.resourceName] = {
          hasAccess: item.hasAccess,
          employeeId: employee.id,
          resourceId: item.resourceId,
          accessEntryId: item.accessEntryId
        };
        return employee;
      });
      return Number(employee.id) === Number(id);
    });
    return result;
  }

  changeAccess(value) {
    if (angular.isUndefined(value)) {
      return;
    }

    this.disabledCheckbox = true;
    const generalAccess = {
      resourceId: value.resourceId
    };
    if (!value.hasAccess) {
      return this.AccessService.add(value.employeeId, {generalAccess}).then(result => {
        this.disabledCheckbox = false;
        value.hasAccess = true;
        value.accessEntryId = result.id;
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Dodano uprawnienie')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
        .catch(error => {
          this.disabledCheckbox = false;
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          ).then(() => {
            this.$state.reload();
          });
        });
    }

    return this.AccessService.delete(value.accessEntryId).then(() => {
      this.disabledCheckbox = false;
      value.hasAccess = false;
      value.accessEntryId = null;
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto uprawnienie')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.disabledCheckbox = false;
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        ).then(() => {
          this.$state.reload();
        });
      });
  }
}

export const Permissions = {
  bindings: {
    me: '<',
    employees: '<',
    access: '<'
  },
  template,
  controller: PermissionsComponent
};
